module.exports = __webpack_public_path__ + "img/9791187206446.29b38bfb.jpg";